import React from "react";
import { Link } from "react-router-dom";

function CategoriesdetailCard({ item }) {
  return (  
    <div className="catg-detail-card">
      <Link
        to={`/categories/${item?.slug || item?.slugPath}`}
        className="catg-detail-card-inner"
      >
        {/* LEFT: Image */}
        <div className="catg-detail-card-image">
          {item?.image && <img src={item.image} alt="category" />}
        </div>

        {/* RIGHT: Content */}
        <div className="catg-detail-card-content">
          <h3 className="catg-detail-card-title">{item?.name}</h3>

          <p  className="custom-det-catg-desc  ">{item?.shortDescription?.slice(0, 60)}...</p>

          {/* <div className="catg-detail-card-btn-wrapper">
            <span className="catg-detail-card-btn">View More</span>
          </div> */}
        </div>
      </Link>
    </div>
  );
}

export default CategoriesdetailCard;
